import { styled } from '@mui/material';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';
interface IBoldStyledProps {
  attrs?: {
    error?: boolean;
  };
}

export const BoldStyled = styled('b')<IBoldStyledProps>(
  ({ theme, attrs: { error } = {} }) => ({
    ...(error && {
      color: theme.palette.error.main,
    }),
  }),
);

export const ExclamationTriangleIconStyled = styled(ExclamationTriangleIcon)(
  ({ theme }) => ({
    color: theme.palette.white.main,
    fill: theme.palette.error.main,
    width: '24px',
    height: '24px',
  }),
);
